/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, CALL THEM ONLY
 *
 * **/
// document event listeners
document.addEventListener('scroll', () => {
    initRecaptcha();
});
const cardsAnimationTiming = 300;
document.addEventListener('DOMContentLoaded', (event) => {
    initFormFieldsToggle();
    initFormsValidation();
    initModalResponse();
    initIubendaProof();
    initLoadMore();
    initFilter();
    initVideo();
    initMapScript();
    initSwitchLanguage();
    initMobileMenu();
    initCardsAnimation(cardsAnimationTiming);
    initFadeInAnimations();
    initImageGalleryWidget();
    initRelatedUsageAreasWidget();
    initTextImageExtendedBlockReadMore();
    initRelatedPreparationsWidget();
    initMultimediaGalleryWidget();
    initMultipleHeadingWidget();
    initHeadingVideo();
    jsLazyLoadImages();
    initRotatingHeadingComponent();
    initProductColorsWidget();
    initMediaVideoComponent();
    initImageBanner();
    shopifyGTMEvent();
    initIncludedOptionalsWidget();
});
